/**
 * Custom Element pour le statut téléphonique dans le header mobile
 * Utilise l'utilitaire partagé PhoneStatusUtils
 */
class MobileHeaderTopbar extends HTMLElement {
  constructor() {
    super();
    this.statusManager = null;
    console.log('[MobileHeaderTopbar] constructor');
  }

  connectedCallback() {
    console.log('[MobileHeaderTopbar] connectedCallback');
    // Attendre que le DOM soit prêt (children parsés)
    requestAnimationFrame(() => {
      this.initializeStatus();
      this.initializeTracking();
    });
  }

  initializeTracking() {
    const details = this.querySelector('.mobile-header-topbar__details');
    if (!details) {
      return;
    }

    details.addEventListener('toggle', () => {
      // On ne pousse l'event qu'à l'ouverture du dropdown
      if (!details.open) {
        return;
      }

      const eventData = {
        menu_location: 'header',
        menu_parent: '',
        section_name: '',
        menu_label: 'Être rappelé par un expert',
      };

      if (typeof window.trackEvent === 'function') {
        window.trackEvent('menu_interaction', eventData);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'menu_interaction', ...eventData });
      }
    });
  }

  initializeStatus() {
    console.log('[MobileHeaderTopbar] initializeStatus');

    // Attendre que l'utilitaire soit chargé
    if (typeof window.PhoneStatusUtils === 'undefined') {
      console.log('[MobileHeaderTopbar] PhoneStatusUtils not ready, retrying...');
      setTimeout(() => this.initializeStatus(), 50);
      return;
    }

    const statusDot = this.querySelector('.mobile-header-topbar__status-dot');
    console.log('[MobileHeaderTopbar] statusDot:', statusDot);

    if (!statusDot) {
      console.log('[MobileHeaderTopbar] No statusDot found, aborting');
      return;
    }

    console.log('[MobileHeaderTopbar] Creating statusManager...');
    this.statusManager = window.PhoneStatusUtils.createStatusManager({
      element: this,
      statusElement: statusDot,
      availableClass: 'mobile-header-topbar__status-dot--available',
      unavailableClass: 'mobile-header-topbar__status-dot--unavailable',
    });

    console.log('[MobileHeaderTopbar] statusManager created:', this.statusManager);
    console.log('[MobileHeaderTopbar] isOpen:', this.statusManager.isOpen());

    this.statusManager.start();
    console.log('[MobileHeaderTopbar] statusManager started');
  }

  disconnectedCallback() {
    if (this.statusManager) {
      this.statusManager.stop();
    }
  }
}

customElements.define('mobile-header-topbar', MobileHeaderTopbar);
